import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import CheckRoundIcon from "../../Icons/CheckRound";
import LinkComponent from "../Link";
import useWidthHook from "../../Hooks/useWidth";

/**
 * props definition
 */
const propTypes = {
  withCheckbox: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.any.isRequired,
      slug: PropTypes.string.isRequired
    })
  ),
  activeKey: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  children: PropTypes.any
};

const defaultProps = {
  withCheckbox: true,
  onSelect: () => {}
};

const Side = ({
  tabs,
  children,
  onSelect,
  activeKey,
  withCheckbox,
  ...props
}) => {
  /**
   * hooks
   */
  const width = useWidthHook();

  /**
   * variables
   */
  const activeIndex = tabs.findIndex((i) => i.slug === activeKey);

  return (
    <Wrapper {...props}>
      {width >= 1200 && (
        <Sidenav className="side-tab__nav">
          {tabs?.map(({ slug, name }, key) => (
            <Item
              key={key}
              state={
                activeIndex === key
                  ? "active"
                  : withCheckbox && activeIndex > key
                  ? "complete"
                  : "stale"
              }
              className="side-tab__nav__item"
              onClick={() => onSelect && onSelect(slug)}
            >
              {withCheckbox && activeIndex > key && (
                <CheckRoundIcon color="var(--bs-primary)" />
              )}
              <span>{name}</span>
            </Item>
          ))}
        </Sidenav>
      )}
      <Content className="side-tab__content">{children}</Content>
    </Wrapper>
  );
};

/**
 * styles
 */
const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 54.75rem;

  @media (min-width: 1200px) {
    margin: 0;
  }
`;

const Item = styled(LinkComponent)`
  color: #000;
  gap: 0.75rem;
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;

  ${({ state }) => {
    switch (state) {
      case "complete":
        return `
            color: var(--bs-primary);
        `;
      case "active":
        return `
            font-weight: 600;
            background-color: var(--bs-gray-20);
        `;
      default:
        return `
          color: var(--bs-gray);
        `;
    }
  }}
`;

const Sidenav = styled.div`
  gap: 0.5rem;
  display: grid;
  position: sticky;
`;

const Wrapper = styled.div`
  @media (min-width: 1200px) {
    gap: 6.5rem;
    display: grid;
    align-items: flex-start;
    grid-template-columns: 17rem minmax(0, 1fr);
  }
`;

Side.propTypes = propTypes;
Side.defaultProps = defaultProps;

export default Side;
